export default __webpack_public_path__ + "static/media/compass5.ca084845.png";